import {cn} from 'utils/cn'
import {resolveSharpetArt} from './manifest'

/**
 * Draws a Sharpet. Every surface that shows a pet (the launcher, the chat
 * panel, a profile) goes through this component and nothing else reads the
 * manifest, so moving from still images to sprite sheets or layered
 * cosmetics changes this file only.
 *
 * The wrapper is a positioned square standing in for the 512px canvas at
 * `size`, so later layers can place themselves at a manifest anchor as a
 * percentage of it (a hat at the head anchor is at 50% / 18%).
 *
 * Decorative by default; pass `label` when the pet is the only thing
 * identifying a control.
 */
const Sharpet = ({
  species,
  mood = 'idle',
  size = 96,
  animated = true,
  label,
  className,
}) => {
  const {src} = resolveSharpetArt(species, mood)

  return (
    <span
      role={label ? 'img' : undefined}
      aria-label={label || undefined}
      aria-hidden={label ? undefined : 'true'}
      className={cn('relative inline-block shrink-0 select-none', className)}
      style={{width: size, height: size}}
    >
      <img
        src={src}
        alt=""
        draggable={false}
        className={cn(
          'absolute inset-0 h-full w-full',
          animated && 'origin-bottom animate-sharpet-breathe'
        )}
      />
    </span>
  )
}

export default Sharpet
